import { defineField, defineType } from "sanity";
import { PortableTextBlock } from "sanity";

export const DEFAULT_LANGUAGE = "en";
export const NON_DEFAULT_LANGUAGES = ["de", "br"];

export const I18nTextType = defineType({
  name: "i18nText",
  type: "object",
  title: "Translations",
  options: {
    collapsible: true,
    collapsed: true,
  },
  fields: [
    defineField({
      name: "de",
      title: "Deutsch",
      type: "string",
    }),
    defineField({
      name: "br",
      title: "Português (BR)",
      type: "string",
    }),
  ],
});

export interface II18nText {
  de?: string;
  br?: string;
}

export function resolveI18nText(
  defaultText: string | undefined,
  i18n: II18nText | undefined,
  language: string | undefined,
): string {
  const text = defaultText ?? "";
  if (!language || language === DEFAULT_LANGUAGE) return text;
  return i18n?.[language as keyof II18nText] || text;
}

export const I18nRichtextType = defineType({
  name: "i18nRichtext",
  type: "object",
  title: "Translations",
  options: {
    collapsible: true,
    collapsed: true,
  },
  fields: [
    defineField({
      name: "de",
      title: "Deutsch",
      type: "richtext",
    }),
    defineField({
      name: "br",
      title: "Português (BR)",
      type: "richtext",
    }),
  ],
});

export interface II18nRichtext {
  de?: PortableTextBlock[];
  br?: PortableTextBlock[];
}

export function resolveI18nRichtext(
  defaultContent: PortableTextBlock[] | undefined,
  i18n: II18nRichtext | undefined,
  language: string | undefined,
): PortableTextBlock[] | undefined {
  if (!language || language === DEFAULT_LANGUAGE) return defaultContent;
  return i18n?.[language as keyof II18nRichtext] ?? defaultContent;
}
